export default {
  custodiansList: [],
  custodians: {
    totalItems: 0,
    data: [],
  },
};
